import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CircleMinus from './icon-circle-minus.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CircleMinus {...validProps} />;
}
SvgComponent.iconName = 'circleMinus';

/**
 * @deprecated This is a legacy icon
 */
export const CircleMinusIcon = svgIconWrapper(SvgComponent);
